function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "m13.1 3.29c0-1.54-1.25-2.79-2.79-2.79h-7.02c-1.54 0-2.79 1.25-2.79 2.79v8.33c0 1.04.85 1.88 1.91 1.88h10.82c.7 0 1.27-.56 1.27-1.25v-7.57c0-.69-.7-1.39-1.4-1.39zm-11.2 0v-.23c0-.64.52-1.17 1.17-1.17h7.47c.64 0 1.17.52 1.17 1.17v.23zm8.67 6.39c-.77 0-1.39-.62-1.39-1.38s.62-1.38 1.39-1.38 1.39.62 1.39 1.38-.62 1.38-1.39 1.38z",
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 15 14"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/wallet-outlined.d07479ae.svg";
export { SvgComponent as ReactComponent };